import TalkGif from '../../../../public/images/talk.gif';
import Character0 from '../../../../public/images/character0.png';
import Character1 from '../../../../public/images/character1.png';
import Character2 from '../../../../public/images/character2.png';
import Character3 from '../../../../public/images/character3.png';

export const Talk = TalkGif;
export const selectCharacter = (episodeNumber) => {
  switch (episodeNumber) {
    case '0':
      return Character0;
    case '1':
      return Character1;
    case '2':
      return Character2;
    case '3':
    default:
      return Character3;
  }
};
